<template>
  <PaymentBox>
    <BoxContent
      title="Pagamento não foi concluído."
      icon="PixIcon"
      :animated="true"
      :success="false"
    >
      <div class="payment__buttons">
         <VButton @click.native="generateNewPix()" text="Gerar novo código Pix" />
         <VButton @click.native="goToPaymentMethods()" style="margin-top: 16px;" variant="tertiary" text="Alterar forma de pagamento" />
      </div>
    </BoxContent>
    <BoxContent style="margin-top: 32px;">
      <span class="payment__box-description">Caso você já tenha realizado o pagamento selecione a opção abaixo</span>
      <VButton @click.native="toggleDrawer()" style="margin-top: 16px;" variant="tertiary" text="Instruções para prosseguir" />
    </BoxContent>
    <DrawerBottom :open="openDrawer" @toggle="openDrawer = !openDrawer" @close="openDrawer = false" v-if="openDrawer">
      <template #content>
        <div class="drawer-content">
          <h3 class="drawer__title">Caso já tenha feito o pagamento</h3>

          <ul class="drawer__list">
            <li>
               <strong>1º passo</strong>
               <span>Retire uma senha no guichê de atendimento.</span>
            </li>
            <li>
               <strong>2º passo</strong>
               <span>Informe ao atendente que foi realizado o check-in e apresente o comprovante de pagamento do Pix.</span>
            </li>
         </ul>

         <VButton text="Ir para o guichê" @click.native="goToServiceDesk()" />
        </div>
      </template>
    </DrawerBottom>
  </PaymentBox>
</template>

<script>
import PaymentBox from '@/components/layout/PaymentBox';
import BoxContent from '@/components/payments/BoxContent';
import DrawerBottom from '@/components/drawerBottom.component.vue';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'PaymentPix',
  components: {
    PaymentBox,
    BoxContent,
    DrawerBottom
  },
  mixins: [dataLayersMixin],
  data() {
    return {
      openDrawer: false
    };
  },
  created() {
    this.mostCommonPagesAnalytics({
      step: 'seleção_cartão_ou_particular',
      screen: 'pagamento_recusado_pix',
      complementaryObject: {
        payment: {
          type: 'particular_com_pix',

        },
      }
    });
  },
  methods: {
    generateNewPix() {
      return this.$router.push({ name: 'pix-payment' });
    },
    goToPaymentMethods() {
      return this.$router.push({ name: 'payment-methods' });
    },
    toggleDrawer() {
      this.openDrawer = !this.openDrawer;
      if (this.openDrawer) {
        this.mostCommonPagesAnalytics({
          step: 'seleção_cartão_ou_particular',
          screen: 'instruções_pix',
          complementaryObject: {
            payment: {
              type: 'particular_com_pix',

            },
          }
        });
      }
    },
    goToServiceDesk() {
      return this.goNextStep('end_flow_success');
    }
  }
};
</script>

<style lang="scss" scoped>
   .payment__buttons {
      margin-top: 24px;
   }
   .payment__box-description {
      font-weight: 700;
      font-size: 16px;
      line-height: 150%;
   }
   .drawer__title {
   font-weight: 700;
   font-size: 20px;
   margin-bottom: 24px;
}

.drawer__list {
   color: #797C86;
   font-size: 16px;

   strong {
      font-weight: 700;
      display: block;
   }

   span {
      font-weight: 300;
   }

   li {
      display: block;
         margin-bottom: 24px;
   }
}
</style>
